module.exports = __webpack_public_path__ + "h5/img/master_2.a99a6392.jpg";